import styled from 'styled-components';

export const Grid2Columns = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20pt;
`;

export const PdfPage = styled.div`
  width: 100%;
  page-break-before: always;
  white-space: pre-wrap; /* Allows wrapping and breaks long words*/
  overflow-wrap: break-word;
  word-break: normal;
  padding-top: 16pt;

  &:empty {
    display: none;
  }
`;

export const EPDCertificatePdfPage = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: row;
  width: 100%;
  page-break-after: always;
`;

export const PdfCoverPage = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  page-break-after: always;
`;

export const PdfH1 = styled.div`
  text-transform: uppercase;
  color: ${(props) => props.theme.colors.primaryGreen};
  font-size: 14pt;
  font-weight: 600;
  font-family: Inter;
  line-height: 14pt;
  margin-bottom: 12pt;
  page-break-after: avoid;
  break-after: avoid;
`;

export const PdfH3 = styled(PdfH1)`
  text-transform: none;
`;

export const PdfH2 = styled(PdfH1)`
  margin-bottom: 12pt;
  text-transform: none;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  font-size: 12pt;
  line-height: 15pt;
`;

export const PdfP = styled.p`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 10pt;
  line-height: 14pt;
  color: #000000;
`;

export const PdfTable = styled.table`
  table-layout: fixed; /* needed for word-wrap worked properly and speeds up render */
  border-collapse: collapse;
  width: 100%;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 8pt;
  line-height: 14pt;
  color: #000000;
  & > th,
  td {
    border: 1pt solid #c8c8c8;
    padding: 4pt;
    text-align: left;
    vertical-align: top;
  }

  sub {
    vertical-align: baseline;
    position: relative;
    top: 0.33em;
  }
  sup {
    vertical-align: baseline;
    position: relative;
    top: -0.33em;
  }
`;

export const PdfGridsArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;

  &:empty {
    display: none;
  }
`;

export const PdfTableArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  &:empty {
    display: none;
  }
`;

export const PdfAreaDontBreak = styled.div`
  page-break-inside: avoid;
  break-inside: avoid;
  -webkit-column-break-inside: avoid;
  &:empty {
    display: none;
  }
`;

export const PdfAreaBreakPageAlways = styled.div`
  page-break-before: always;
  break-before: always;
  -webkit-column-break-before: always;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
`;

export const TopSection = styled.div`
  flex: 1;
  display: flex;
`;

export const LeftSubsection = styled.div`
  flex: 5;
  padding: 0cm 1cm 0.5cm 1.5cm;
  height: 100%;
`;

export const LeftSubsectionInnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  justify-content: space-between;
`;

export const RightSubsection = styled.div`
  flex: 2;
  padding: 10pt;
  background-color: #b4d0b64d;
  padding: 1cm;
`;

export const RightSubsectionCaption = styled.div`
  color: #000;
  text-align: right;
  font-family: Inter;
  font-size: 12pt;
  font-style: normal;
  font-weight: 600;
  line-height: 16pt;
`;

export const RightSubsectionText = styled.div`
  color: #636363;
  text-align: right;
  font-family: Inter;
  font-size: 10pt;
  font-style: normal;
  font-weight: 400;
  line-height: 12pt;
  margin-bottom: 1rem;
`;

export const SecondSection = styled.div<{ $hasImage?: boolean }>`
  min-height: 100pt;
  max-height: 400pt;
  padding: 0;
  background-color: ${(props) =>
    props.$hasImage ? props.theme.colors.primaryWhite : props.theme.colors.secondaryLightGreen30};
`;

export const ThirdSection = styled.div`
  background-color: white;
  padding: 22pt 40pt;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const DeclarationHeader = styled.p`
  color: #1e6052;
  font-family: Inter;
  font-size: 26pt;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-transform: uppercase;
  margin: 0;
`;

export const DeclarationName = styled.p`
  color: #000;
  font-family: Inter;
  font-size: 20pt;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin: 0;
`;

export const DeclarationAccordance = styled.p`
  color: #000;
  font-family: Inter;
  font-size: 12pt;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export const ProductsIncludedHeader = styled.p`
  color: #000;
  font-family: Inter;
  font-size: 10pt;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;

export const ProductsIncluded = styled.p`
  color: #646363;
  font-family: Inter;
  font-size: 10pt;
  font-style: normal;
  font-weight: 400;
  line-height: 14pt;
`;

export const BottomText = styled.p`
  color: #646363;
  font-family: Inter;
  font-size: 8pt;
  font-style: normal;
  font-weight: 400;
  line-height: 12pt;
`;

export const GreenLeftLine = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 0.4cm;
  max-width: 0.4cm;
  height: 100vh;
  border-left: 0.4cm solid #1e6052;
  box-sizing: border-box;
`;

export const PdfThLabel = styled.th`
  width: 30%;
`;

export const PdfTdLabel = styled.td`
  width: 30%;
`;

export const PdfGridsAreaBreak = styled(PdfGridsArea)`
  page-break-after: always;
`;

export const PdfHtmlContent = styled.div`
  p {
    margin: 0;
  }
`;
